module.exports = __webpack_public_path__ + "img/vertical_6_5_9016.4225001c.png";